import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ViewModal from "./viewModal";
import DataLoader from "../../Component/Loader/DataLoader";
import { loadNewsletterData } from "./Slice/newsletterSlice";

function Index(props) {
  const dispatch = useDispatch();
  const history = useNavigate();
  
  // Get data from Redux store - fix the state path
  const { NewsletterData, loading, error } = useSelector((state) => state.newsletter || { NewsletterData: [], loading: false, error: null });
  const { setting } = useSelector((state) => state.setting || {});
  
  const [getViewModal, setGetViewModal] = useState(false);
  const [getViewData, setGetViewData] = useState({});
  const { slug } = useParams();
  const params = slug;

  useEffect(() => {
    dispatch(loadNewsletterData());
  }, [dispatch]);

  const resoucesPages = async (e, name, slug) => {
    e.preventDefault();
    history(`/resource-hub/${slug}`);
  };

  const redirectNewsletter = async (e) => {
    e.preventDefault();
    history("/newsletter");
  };

  const redirectVideos = async (e) => {
    e.preventDefault();
    history("/videos");
  };

  const resoucesDrop = [{
    'name': 'All posts',
    'slug': 'all-posts',
    'value': '0',
    'class': 'fas fa-mail-bulk',
    'key': '0'
  },
  {
    'name': 'People stories',
    'slug': 'people-stories',
    'value': '1',
    'class': 'fas fa-user-clock',
    'key': '1'
  },
  {
    'name': 'Points of view',
    'slug': 'points-of-view',
    'value': '2',
    'class': 'fas fa-street-view',
    'key': '2'
  },
  {
    'name': 'Toolkits',
    'slug': 'toolkits',
    'value': '3',
    'class': 'fas fa-toolbox',
    'key': '3'
  }
  ];

  const siteName = setting?.name?.trim() || "Newsletter";

  useEffect(() => {
    const title = `${siteName} - Newsletter`;
    document.title = title;
  }, [siteName]);

  const onViewModal = (e, description, title) => {
    e.preventDefault();
    setGetViewModal(true);
    setGetViewData({
      type: 'newsletter',
      title: title + ' Newsletter',
      item: description
    })
  };


 

  return (
    <div>
      <section className="outer_main">
        <Container className="page_heading text-center">
          <h1>Resources (Newsletter)</h1>
        </Container>
        <div className="page_content">
          <Container>
            <div className="linkpart linkresorce">
              <ul style={{ border: 'none', backgroundColor:"white" }}>
                {resoucesDrop.map((item, key) => (
                  <li key={item.id} className={(item.slug === params) ? 'linkpart-active' : ''} style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                    <button onClick={(e) => {
                      resoucesPages(e, item.name, item.slug);
                    }} style={{ border: 'none', backgroundColor:"white" }}>
                      <i className={item.class}></i>
                      <h6>{item.name}</h6>
                    </button>
                  </li>
                ))}
                <li className="linkpart-active" style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                  <button onClick={(e) => {
                    redirectNewsletter(e);
                  }} style={{ border: 'none', backgroundColor:"white" }}>
                    <i className="fas fa-envelope-open-text"></i>
                    <h6>Newsletter</h6>
                  </button>
                </li>
                <li style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                  <button onClick={(e) => {
                    redirectVideos(e);
                  }} style={{ border: 'none', backgroundColor:"white" }}>
                    <i className="fas fa-video"></i><h6>Videos</h6>
                  </button>
                </li>
              </ul>
            </div>
            <div className="page_content_inner removecol_condition p-0">
              {loading && <DataLoader />}
              
              {!loading && error && (
                <div className="text-center text-danger">Error loading newsletter data: {error}</div>
              )}
              
              {!loading && !error && Array.isArray(NewsletterData) && NewsletterData.length > 0 && (
                <Row>
                  {NewsletterData.map((item) =>
                  (
                    <Col md={4} sm={6} className="news-listing" key={item.id}>
                      <div className="newslleter-cols">
                        <figure>
                          <button
                            type="button"
                            className="image-button"
                            onClick={(e) =>
                              onViewModal(e, item.description, item.publish_date_formatted)
                            }
                          >
                            <img
                              src={item.image}
                              alt={item.title || 'Newsletter'}
                              className="cursor-pointer"
                            />
                          </button>

                          <figcaption>
                            {item.publish_date_formatted && (
                              <span className="post-date">
                                Edition: {item.publish_date_formatted}
                              </span>
                            )}
                          </figcaption>
                        </figure>
                      </div>
                    </Col>
                  ))}
                </Row>
              )}

              {!loading && !error && (!Array.isArray(NewsletterData) || NewsletterData.length === 0) && (
                <div className="text-center" style={{textAlign: "center"}}>No newsletter data found.</div>
              )}
            </div>
          </Container>
        </div>
      </section>
      {
        getViewModal && (
          <ViewModal
            show={getViewModal}
            viewdata={getViewData}
            onHide={() => setGetViewModal(false)}
            centered
            size="xl"
          />
        )
      }
    </div>
  );
}

Index.propTypes = {
  // Props are now optional since we're using Redux
};

export default Index;

